import { useEffect, useState } from 'react';
import ChatLayout from './Layout';
import { ChatMenu } from './ChatMenu';
import { getInquiry } from '@/services/api/chatService';
import { httpServices } from '@/services/axiosClient';
import { useAppContext } from '@/context';
import ChatWindow from './ChatWindow';

const ChatPage = ({ reloadData }: any) => {
  const { user, setUser } = useAppContext();
  const [selectedInquiry, setSelectedInquiry] = useState<any>();
  const [selectedInquiryId, setSelectedInquiryId] = useState<any>();
  const [inquiries, setInquiries] = useState<any>([]);

  const orgView = !!user?.is_organization_view;

  const setOrgView = async (newValue: boolean) => {
    // Optimistic update
    setUser((prev: any) => ({ ...prev, is_organization_view: newValue }));

    try {
      await httpServices.llmService.post('/organization/settings/view', {
        is_organization_view: newValue,
      });

      // Refetch inquiries after backend confirms the toggle
      const params: any = { projects_id: '' };
      const response = await getInquiry(params);
      if (response.success) {
        setInquiries(response.data);
      }
    } catch (e) {
      console.error('Failed to update organization view setting', e);
      // Revert if failed
      setUser((prev: any) => ({ ...prev, is_organization_view: !newValue }));
    }
  };

  useEffect(() => {
    const getInquiries = async () => {
      const params: any = { projects_id: '' };
      const response = await getInquiry(params);
      if (!response.success) {
        return;
      }
      setInquiries(response.data);
    };
    getInquiries();
  }, []);

  return (
    <ChatLayout>
      <ChatMenu
        inquiries={inquiries}
        setInquiries={setInquiries}
        selectedInquiry={selectedInquiry}
        setSelectedInquiry={setSelectedInquiry}
        selectedInquiryId={selectedInquiryId}
        setSelectedInquiryId={setSelectedInquiryId}
        orgView={orgView}
        setOrgView={setOrgView}
      />
      <ChatWindow
        selectedInquiryId={selectedInquiryId}
        reloadData={reloadData}
      />
    </ChatLayout>
  );
};

export default ChatPage;
